module.exports = __webpack_public_path__ + "img/40_38_091_940.d72a44e1.jpg";